"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { ApiWave } from "@/generated/models/ApiWave";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "@/components/auth/Auth";
import WaveHeaderNameEdit from "./WaveHeaderNameEdit";
import { canEditWave } from "@/helpers/waves/waves.helpers";
import { getWavePathRoute } from "@/helpers/navigation.helpers";
export default function WaveHeaderName(t0) {
  const $ = _c(24);
  const {
    wave
  } = t0;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  let t1;
  if ($[0] !== activeProfileProxy || $[1] !== connectedProfile || $[2] !== wave) {
    t1 = () => canEditWave({
      connectedProfile,
      activeProfileProxy,
      wave
    });
    $[0] = activeProfileProxy;
    $[1] = connectedProfile;
    $[2] = wave;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getShowEdit = t1;
  let t2;
  if ($[4] !== getShowEdit) {
    t2 = getShowEdit();
    $[4] = getShowEdit;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const [showEdit, setShowEdit] = useState(t2);
  let t3;
  if ($[6] !== getShowEdit) {
    t3 = () => setShowEdit(getShowEdit());
    $[6] = getShowEdit;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== connectedProfile || $[9] !== wave) {
    t4 = [connectedProfile, wave];
    $[8] = connectedProfile;
    $[9] = wave;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  useEffect(t3, t4);
  let t5;
  if ($[11] !== wave.id) {
    t5 = getWavePathRoute(wave.id);
    $[11] = wave.id;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== wave.name) {
    t6 = <h1 className="tw-mb-0 tw-text-lg tw-font-semibold tw-tracking-tight tw-text-iron-50 tw-transition tw-duration-300 tw-ease-out desktop-hover:group-hover:tw-text-iron-400 sm:tw-text-xl">{wave.name}</h1>;
    $[13] = wave.name;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <Link href={t5} className="tw-no-underline">{t6}</Link>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== showEdit || $[19] !== wave) {
    t8 = showEdit && <div className="tw-mt-[7px] tw-size-4"><WaveHeaderNameEdit wave={wave} /></div>;
    $[18] = showEdit;
    $[19] = wave;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t7 || $[22] !== t8) {
    t9 = <div className="tw-group tw-flex tw-items-start tw-space-x-2">{t7}{t8}</div>;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}